import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { StorageService } from './storage.service';
import {environment} from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class ApiService {

  private baseUrl: string;
  private userApiUrl: string;

  constructor(
    private authService: AuthenticationService,
    private http: HttpClient,
    private router: Router,
    private storageService: StorageService
  ) {
    this.baseUrl = environment.api_url;
    this.userApiUrl = environment.api_user_url;
  }
  // : Observable<HttpResponse<any>>
  public delete(path: string, options?: any): Observable<any> {
    return this.request(path, 'delete', options);
  }

  public get(path: string, options?: any): Observable<any> {
    return this.request(path, 'get', options);
  }

  public post(path: string, options?: any, isUserApi: boolean = false): Observable<any> {
    return this.request(path, 'post', options, isUserApi);
  }

  public put(path: string, options: any): Observable<any> {
    return this.request(path, 'put', options);
  }

  public patch(path: string, options: any): Observable<any> {
    return this.request(path, 'patch', options);
  }

  private request(path: string, method: string, options?: any, isUserApi: boolean = false): Observable<any> {
    options = options || {};
    let headers = null;
    let url = `${this.baseUrl}${path}`;
    if (isUserApi) {
      url = `${this.userApiUrl}${path}`;
    }
    const token = this.storageService.getItem('token');
    if (token) {
      headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Authorization', token);
    } else {
      headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
    }
    const requestOptions = Object.assign(options, {
      headers: headers
    });
    return this.http.request(method, url, requestOptions).pipe(
      tap (
        (event: any) => {
          if (event.status === 401 && event.error_fields.message === 'Access Token has expired') {
            this.refreshToken();
          }
        }
      ),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  public refreshToken() {
    this.authService.getRefreshToken().then((token: string) => {
      if (token.length > 0) {
        const body = {'refresh_token': token};
        this.http.post(`${this.baseUrl}m0wmgrecc6.execute-api.eu-west-1.amazonaws.com/api_v1/user/token/refresh`, body)
          .subscribe((response: any) => {
            if (response.status === 201) {
              this.authService.parseRefreshToken(response).then(result => {
                console.log('here');
                window.location.reload();
              });
            } else {
              this.authService.clearSignin();
              this.router.navigate(['/signin']);
            }
          });
      } else {
        this.authService.clearSignin();
        this.router.navigate(['/signin']);
      }
    });
  }

}
